import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../../../services/grupo.service';
import { EmpresaService } from '../../../../services/empresa.service';
import { MesService } from '../../../../services/mes.service';
import { AnioService } from '../../../../services/anio.service';
import { ExcepcionService } from '../../../../services/excepcion.service';

@Component({
  selector: 'app-aperturaporempresa',
  templateUrl: './aperturaporempresa.component.html',
  styleUrls: ['./aperturaporempresa.component.css'],
  providers: [GrupoService, EmpresaService, MesService, AnioService, ExcepcionService]
})
export class AperturaporempresaComponent implements OnInit {
  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public empresas: any = null;
  public meses: any = null;
  public anios: any = null;
  public excepciones: any = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _empresaService: EmpresaService,
    private _mesService: MesService,
    private _anioService: AnioService,
    private _excepcionService: ExcepcionService
  ) {
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.getEmpresas();
  }

  getEmpresas() {
    this._empresaService.getEmpresasActivas(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.empresas = response.empresas;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  getAnios() {
    this.meses = null;
    this.anios = null;
    this._anioService.getAnios(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.anios = response.anios;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  getMeses() {
    this._mesService.getMeses(this.token).subscribe(
      response => {
        if (response.status == 'success') {
          this.meses = response.meses;
          this.getExcepciones();
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  getExcepciones() {
    var empresa_id = $("#empresa_id").val();
    var anio_id = $("#anio_id").val();

    this._excepcionService.getExcepcionesPorEmpresa(this.token, empresa_id, anio_id).subscribe(
      response => {
        if (response.status == 'success') {
          this.excepciones = response.exceptions;
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );
  }

  doExcepcion(mes_id) {
    var empresa_id = $("#empresa_id").val();
    var anio_id = $("#anio_id").val();

    let info = {
      'empresa_id': empresa_id,
      'anio_id': anio_id,
      'mes_id': mes_id,
    }

    this._excepcionService.doExcepcion(this.token, info).subscribe(
      response => {
        if (response.status == 'success') {
          $(".excepcion").show();

          this.status = response.status;
          this.message_success = response.message;
          this.getExcepciones();
          setTimeout(function () {
            $(".excepcion").fadeTo(500, 1).slideUp(500, function () {
              $(".excepcion").hide();
            });
          }, 3000);

        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          alert('Existe problemas con el servidor, favor de intentar más tarde');
        }
      }
    );

  }

}
